module.exports = __webpack_public_path__ + "static/media/twohundredgoals.1e584f32.jpg";